/** Geometry and rim of a health bar, in whole pixels. */
export interface HealthBarStyle {
  width: number;
  height: number;
  rim: number;
}

/** Everyone else's bar: small and dark-rimmed, so a crowd stays readable. */
export const OTHER_BAR: HealthBarStyle = { width: 16, height: 3, rim: 0x12121c };

/**
 * The local player's bar (SHE-35): wider, taller, and rimmed in pale parchment,
 * so it is found at a glance among the monsters' dark-rimmed ones.
 */
export const SELF_BAR: HealthBarStyle = { width: 20, height: 4, rim: 0xf0e6c8 };

/** Above every character and prop (depth = feet y, at most 384 × 16), under the floating numbers (20 000). */
export const SELF_BAR_DEPTH = 15_000;

export interface HealthBarFill {
  /** Hidden at full health, like BrowserQuest. */
  shown: boolean;
  /** Width of the fill inside the 1 px rim, at least 1 while alive. */
  fillWidth: number;
  color: number;
}

export function healthBarFill(hp: number, maxHp: number, style: HealthBarStyle): HealthBarFill {
  const shown = maxHp > 0 && hp < maxHp;
  const ratio = maxHp > 0 ? Math.max(0, Math.min(1, hp / maxHp)) : 1;
  return {
    shown,
    fillWidth: Math.max(1, Math.round((style.width - 2) * ratio)),
    color: ratio <= 1 / 3 ? 0xff5c5c : ratio <= 2 / 3 ? 0xf0c050 : 0x9ece6a,
  };
}
